import React, { FC } from 'react';

import { StyledButton, StyledIcon, StyledLabel, StyledString } from './styled';

interface DeleteButtonStringProps {
  label: string;
  onClick: () => void;
}

const DeleteButtonString: FC<DeleteButtonStringProps> = ({
  label,
  onClick,
}) => (
  <StyledString>
    <StyledButton onClick={onClick}>
      <StyledIcon />
      <StyledLabel>{label}</StyledLabel>
    </StyledButton>
  </StyledString>
);

export default DeleteButtonString;
